import React, { useEffect, useState, useRef } from 'react';
interface LazySectionProps {
  children: ReactNode;
  threshold?: number;
  rootMargin?: string;
  className?: string;
}
export function LazySection({
  children,
  threshold = 0.01,
  rootMargin = '100px',
  className = ''
}: LazySectionProps) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold,
      rootMargin
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [threshold, rootMargin]);
  return <div ref={sectionRef} className={className} data-id="element-156">
      {isVisible ? children : <div style={{
      minHeight: '200px'
    }} data-id="element-157" />}
    </div>;
}